/** @flow */
import React from "react";
import { localize } from "redux-i18n";
import { Button, ModalFooter, Text, View } from "@components";
import { SchemaForm } from "@components";
import { FormHeader } from "@modules/client/components";
import type {
  ClientServiceAbsenceManagement,
  AbsenceManagementSettings,
  FormResponse,
} from "@modules/client/reducer/service/types";
import uiSchema from "./ui-schema";

type Props = $Exact<{
  ...PropsFromLocalize,
  service: ClientServiceAbsenceManagement,
  schema: Object,
  submitForm: ClientServiceAbsenceManagement => void,
  disableEdit?: boolean,
}>;

type OwnState = $Exact<{
  edit: boolean,
}>;

export class ServiceAbsenceAdditionalOptions extends React.Component<Props, OwnState> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  state = {
    edit: false,
  };

  submitForm = () => {
    this.formRef.current.submit();
  };

  submitHandler = (formData: FormResponse<AbsenceManagementSettings>) => {
    this.props.submitForm({
      ...this.props.service,
      settings: {
        ...formData,
        homeWorkingBlock: false,
        advisorType: "ALL",
        fcaBlock: false,
        aggregatedBenchmark: true,
        nurseTransferType: "ALL",
      },
    });
    this.toggleEdit();
  };

  toggleEdit = () => {
    this.setState({ edit: !this.state.edit });
  };

  cancelEdit = () => {
    this.setState({ edit: false });
  };

  get schema() {
    return this.props.schema || null;
  }

  get uiSchema() {
    return uiSchema(this.props.t);
  }

  get data() {
    return this.props.service?.settings;
  }

  render() {
    return (
      <View gap={3}>
        <View direction="row" justifyContent="space-between" alignItems="center">
          <Text type="h5">{this.props.t("PRODUCTS_AND_FEATURES")}</Text>
          {!this.props.disableEdit && (
            <View direction="row" justifyContent="space-between" gap="4">
              {!this.state.edit ? (
                <Button materialIcon="edit" onClick={this.toggleEdit}>
                  {this.props.t("EDIT")}
                </Button>
              ) : (
                <View direction="row" gap="4">
                  <Button color="secondary" onClick={this.cancelEdit}>
                    {this.props.t("CANCEL")}
                  </Button>
                  <Button
                    materialIcon="replay_circle_filled"
                    className="ml-2"
                    onClick={this.submitForm}
                  >
                    {this.props.t("SUBMIT")}
                  </Button>
                </View>
              )}
            </View>
          )}
        </View>
        {this.data && this.schema && (
          <SchemaForm
            externalSubmit
            schema={this.schema}
            uiSchema={this.uiSchema}
            formData={this.data}
            ref={this.formRef}
            onSubmit={this.submitHandler}
            readonly={!this.state.edit}
            boxGrid
          />
        )}
      </View>
    );
  }
}

export default localize()(ServiceAbsenceAdditionalOptions);
